import React, { forwardRef } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(
  ({ theme, variant: buttonVariant, selected }) => ({
    borderRadius: "16px",
    padding: "12px 25px",
    fontSize: "15px",
    fontWeight: "600",
    textTransform: "none",
    letterSpacing: "0.5px",
    minWidth: "120px",
    position: "relative",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "none",

    // Selected state (contained style)
    ...(selected && {
      background: "linear-gradient(135deg, #053251 0%, #2a5a72 100%)",
      color: "white",
      border: "1px solid rgba(5, 50, 81, 0.3)",
      "&:hover": {
        background: "linear-gradient(135deg, #2a5a72 0%, #1e4159 100%)",
        boxShadow: "0 8px 20px rgba(5, 50, 81, 0.3)",
        transform: "translateY(-2px)",
      },
      "&:active": {
        transform: "translateY(0px)",
      },
    }),

    // Unselected state (outlined style)
    ...(!selected && {
      background:
        "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 255, 254, 0.8) 100%)",
      color: "#053251",
      border: "2px solid rgba(5, 50, 81, 0.2)",
      "&:hover": {
        background:
          "linear-gradient(135deg, rgba(5, 50, 81, 0.05) 0%, rgba(124, 200, 144, 0.05) 100%)",
        borderColor: "rgba(5, 50, 81, 0.4)",
        boxShadow: "0 4px 12px rgba(5, 50, 81, 0.15)",
        transform: "translateY(-1px)",
      },
      "&:active": {
        transform: "translateY(0px)",
      },
    }),

    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "16px",
      padding: "1px",
      background: selected
        ? "linear-gradient(135deg, rgba(124, 200, 144, 0.4), transparent)"
        : "linear-gradient(135deg, rgba(5, 50, 81, 0.2), transparent)",
      mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      maskComposite: "xor",
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
      opacity: selected ? 1 : 0.6,
    },

    "& .MuiButton-startIcon, & .MuiButton-endIcon": {
      transition: "transform 0.3s ease",
    },

    "&:hover .MuiButton-endIcon": {
      transform: "translateX(-4px)",
    },

    "@media (max-width: 768px)": {
      padding: "8px 8px",
      fontSize: "14px",
      minWidth: "100px",
      borderRadius: "16px",
      fontWeight: "500",
      textTransform: "none",
      letterSpacing: "0.5px",
      position: "relative",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: "none",
    },
  })
);

const DateContainer = styled("div")(({ theme }) => ({
  position: "relative",
  marginLeft: "8px",
  "@media (max-width: 768px)": {
    marginLeft: "4px",
  },
}));

const AvailableCountText = styled("span")(({ selected }) => ({
  fontSize: "12px",
  fontWeight: "500",
  marginTop: "6px",
  display: "block",
  transition: "color 0.3s ease",
  color: selected ? "#7cc890" : "rgba(5, 50, 81, 0.7)",
  textAlign: "center",
  letterSpacing: "0.3px",

  "@media (max-width: 768px)": {
    fontSize: "11px",
    marginTop: "4px",
  },
}));

const ReservaDateTimeItme = forwardRef(
  ({ selectedDate, itm, handleDateClick, showAvailableCount }, ref) => {
    const isSelected = selectedDate === itm.date;

    return (
      <DateContainer ref={ref} className="col-auto mt-2">
        <StyledButton
          selected={isSelected}
          variant={isSelected ? "contained" : "outlined"}
          onClick={() => handleDateClick(itm.date, itm.dateDisplay)}
        >
          <span>{itm.dateDisplay}</span>
        </StyledButton>
        <AvailableCountText selected={isSelected}>
          {showAvailableCount ? `${itm.availableTimeCount} نوبت` : ""}
        </AvailableCountText>
      </DateContainer>
    );
  }
);

export default ReservaDateTimeItme;
